import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AlertToaster = {

    success(log) {
        toast.success(log, {
            autoClose: 5000
        });
    },

    info(log) {
        toast.info(log, {
            autoClose: 5000
        });
    },

    warn(log) {
        toast.warn(log, {
            autoClose: 5000
        });
    },

    error(log) {
        toast.error(log, {
            autoClose: 5000
        });
    }
}

export default AlertToaster;